import template from "./index.html";
import "./index.less";
import tabbedModal from "../../../components/modals/tabbed-modal";
import viewExportTabs from "./tabs";
import { EVENT_LOGOUT } from "../../../constants";
import { FORM_EXPORT_LOGS } from "../../../routes";

function controller(
	$scope, 
	eventBus, 
	$logger, 
	appState, 
	api,
	loadingService
) {
	const ctrl = this;

	ctrl.$onDestroy = ctrl.handleClose;

	ctrl.$onInit = () => {
		eventBus.register(EVENT_LOGOUT, () => { ctrl.handleClose(); }, $scope);

		ctrl.formConfig = appState.forms.selected;
		loadingService.watch(loadExportLog());
	};

	ctrl.handleClose = () => {
		ctrl.modalInstance.close();
	};

	async function loadExportLog() {
		ctrl.fullExportLog = await api.get(FORM_EXPORT_LOGS(ctrl.formConfig.Id, ctrl.resolve.exportLog.Id));
	}
}

export const viewExportModal = angular
	.module("vesl.components.view-export", [tabbedModal, viewExportTabs])
	.component("viewExport", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
